var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-7{fill:#999;}.cls-10,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{fill-rule:evenodd;}.cls-4{fill:#b3b3b3;}.cls-5{fill:#9e5031;}.cls-6{fill:#804026;}.cls-8,.cls-9{fill:#222c30;}.cls-10{fill:#4d4d4d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 144,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73,15a54.5,54.5,0,0,1,0,109L69.15,69.5,73,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.61,124s-54.5-24.4-54.5-54.49S43.31,15,72.61,15V124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112,77.28a7.79,7.79,0,1,0,7.79,7.79A7.79,7.79,0,0,0,112,77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112,81.17a3.9,3.9,0,1,0,3.9,3.9,3.9,3.9,0,0,0-3.9-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.75,77.28a7.79,7.79,0,1,0,7.79,7.79,7.78,7.78,0,0,0-7.79-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.75,81.17a3.9,3.9,0,1,0,3.89,3.9,3.9,3.9,0,0,0-3.89-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,44.87a38.57,38.57,0,0,1,8.7,24.63v38.92a38.53,38.53,0,1,1-77.05,0V69.5a38.47,38.47,0,0,1,8.58-24.63A53.57,53.57,0,0,0,73.1,53.93,53.57,53.57,0,0,0,103,44.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M109.5,66.11a2.19,2.19,0,0,1,4.35,0v42.31c0,22.48-17.23,40.88-41.93,40.88l-2.79-8.76,3-8.76a27,27,0,0,0,16.8-6v16.11c13-6.07,20.61-19.12,20.61-33.52V66.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.61,149.3h0s-11.06.87-19.4-4.67c-11.28-7.5-20.75-23.28-20.75-36.21v-41c0-1.08.55-1.95,1.63-1.95s1.63.87,1.63,1.95v41c0,14.4,8.68,26.88,21.7,33V125.83a23.82,23.82,0,0,0,15.19,6h0V149.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45,80.31a2,2,0,0,1,.2-4.06l16.27.81a2,2,0,0,1-.2,4.07L45,80.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.19,80.45a2,2,0,0,1,.14-4.07l16.28.54a2,2,0,0,1-.14,4.07l-16.28-.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 54.15,
    cy: 88.66,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 94.18,
    cy: 88.66,
    r: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77,100.5l-.26-9.45a2.35,2.35,0,0,0-4.7.13h0l.19,7.09-2.37.06a7.08,7.08,0,0,0,.4,14.16l4.72-.14a2.33,2.33,0,0,0,2.28-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.57,95.22H82.4c-.86,0-1.11.64-1.11,1.49V99.8c0,2.55,1.66,5.19,4.2,5.19h7.74c2.55,0,4.34-2.64,4.34-5.19V95.22ZM73.12,92.07a7.65,7.65,0,0,1,5.36,2.11A4.71,4.71,0,0,1,82.4,92h23.2a1.63,1.63,0,0,1,0,3.25h-4.78V99.8a7.32,7.32,0,0,1-7.59,7.36H85.49a7.6,7.6,0,0,1-7.73-7.55,4.56,4.56,0,0,0-4.64-4.54l-1.24-1.5,1.24-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.63,95.22a1.63,1.63,0,0,1,0-3.25H63.84a4.28,4.28,0,0,1,3.66,2.21,9.2,9.2,0,0,1,5.11-2.11v3.09a4.51,4.51,0,0,0-4.38,4.45,7.39,7.39,0,0,1-7.49,7.55H53a7.26,7.26,0,0,1-7.53-7.36V95.22Zm23.21,0H48.74V99.8c0,2.55,1.72,5.19,4.27,5.19h7.73c2.55,0,4.28-2.64,4.28-5.19V96.71c0-.85-.33-1.49-1.18-1.49Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual4);
export default __webpack_public_path__ + "static/media/character-head-individual-4.871396970b8be9c2771f74fbe06999f2.svg";
export { ForwardRef as ReactComponent };